import type { Face2d } from "@logic/lib/mesh"
import { loadFacesIntoStore } from "@logic/lib/mesh"
import { useRecoilTransaction_UNSTABLE } from "recoil"

import type { TransactionOperation } from "~/containers/LegacyDesigner/state/elements/transactions"
import { meshIsValidState } from "~/containers/LegacyDesigner/state/meshIsValid"
import {
  tracingFacesState,
  tracingNodesState,
} from "~/containers/LegacyDesigner/Studio/Debug/Visualizations/tracing-visualization-state"

import {
  areaIndex,
  findAreaState,
  nodeIndex,
  edgeIndex,
  findNodeState,
  findEdgeState,
} from ".."
import { areasOfPanelsIndexState } from "../relations"

export const computeFaces: TransactionOperation = (transactors) => {
  const { get, set } = transactors
  const procedure = loadFacesIntoStore({
    nodeIds: get(nodeIndex),
    edgeIds: get(edgeIndex),
    getNode: (id: string) => get(findNodeState(id)),
    getEdge: (id: string) => get(findEdgeState(id)),
    resetResults: () => set(areaIndex, []),
    addFace: (id: string, face: Face2d) => (
      set(areaIndex, (current) => [...current, id]),
      set(findAreaState(id), (current) => ({ ...current, ...face }))
    ),
    setValid: () => set(meshIsValidState, true),
  })
  const areaIds = get(areaIndex)
  set(areasOfPanelsIndexState, (current) => {
    const previousAreaIds = [...current.core.keys()]
    for (const areaId of areaIds) {
      if (!previousAreaIds.includes(areaId)) {
        current.delete(areaId)
      }
    }

    return current
  })
  set(tracingNodesState, procedure)
  set(tracingFacesState, procedure)
}

export const useComputeFaces = (): (() => void) =>
  useRecoilTransaction_UNSTABLE((transactors) => () => computeFaces(transactors))
